<template>
  <vx-card title="Dónde se atascan los procesos">
    <p class="gw-bajada">
      Tiempo acumulado en cada tipo de validación durante el periodo
      seleccionado. Mide duración, no número de validaciones.
    </p>

    <apexcharts
      v-if="hayDatos"
      type="bar"
      height="300"
      :options="opciones"
      :series="series"
    />
    <p v-else class="gw-sin-datos">No hay tiempo acumulado por validación en este periodo.</p>
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import slaFormat from "../../mixins/slaFormat";

export default {
  name: "SlaTimeByPhase",
  mixins: [slaFormat],
  components: { apexcharts: VueApexCharts },
  props: {
    fases: { type: Array, default: () => [] },
  },

  computed: {
    hayDatos() {
      return this.fases.length > 0 && this.fases.some((f) => f.minutos > 0);
    },

    unidad() {
      return this.unidadPara(this.fases.map((f) => f.minutos));
    },

    series() {
      return [
        {
          name: "Tiempo acumulado",
          data: this.fases.map((f) => this.enUnidad(f.minutos, this.unidad)),
        },
      ];
    },

    opciones() {
      const fases = this.fases;
      const unidad = this.unidad;
      return {
        chart: { type: "bar", toolbar: { show: false } },
        plotOptions: { bar: { horizontal: true, barHeight: "60%" } },
        // Una sola serie, un solo color: la comparación está en el largo de la
        // barra, no en el tono.
        colors: [this.GW_MORADO],
        legend: { show: false },
        dataLabels: {
          enabled: true,
          formatter: (v, ctx) => fases[ctx.dataPointIndex].porcentaje + "%",
          style: { fontSize: "11px", colors: ["#fff"] },
        },
        grid: { borderColor: "#eee" },
        xaxis: {
          categories: fases.map((f) => this.etiquetaValidacion(f.validacion)),
          title: {
            text: unidad.sufijo,
            style: { color: this.GW_GRIS_SUAVE, fontSize: "11px", fontWeight: 400 },
          },
          labels: { style: { colors: this.GW_GRIS_SUAVE, fontSize: "11px" } },
        },
        yaxis: {
          labels: {
            style: { colors: this.GW_GRIS, fontSize: "12px" },
            // Por defecto ApexCharts corta en 160px y deja "Verificación aca…".
            maxWidth: 220,
          },
        },
        tooltip: { y: { formatter: (v) => v + " " + unidad.sufijo } },
      };
    },
  },
};
</script>

<style scoped>
.gw-bajada {
  font-size: 12px;
  color: #9a9a9a;
  margin: -6px 0 14px;
  max-width: 62ch;
}
.gw-sin-datos {
  font-size: 12px;
  color: #9a9a9a;
}
</style>
